<template>
  <div>
    <template v-if="listingIs.bale && listing.meta.baledShape === 'Square' && listing.meta.baledSize">
      <UtilDivider class="mt-3 mb-3" />

      <h3 class="text-xl font-medium">{{ `Square ${listing.meta.baledSize}` }}</h3>

      <p>
        {{ `${this.listing.meta.averageWeight} Kg ${this.$t('formFields.averageBaleWeight')}` }}
      </p>

      <img
        v-if="listing.meta.baledSize !== 'Other'"
        :src="require(`@/assets/images/bales/square/${listing.meta.baledSize}.jpg`)"
        class="mt-2"
        style="height: 250px;"
      />
    </template>

    <h3 class="text-xl font-medium">{{ $t('titles.sampleAnalysis') }}</h3>

    <ListingFiles :listing="listing" class="mt-4 mb-5" />

    <table class="table-auto table-striped-alt w-full mt-2">
      <tbody>
        <tr v-for="item in compSampleAnalysis" :key="item.name">
          <td class="px-2 py-1 md:w-4/12">{{ item.name }}:</td>

          <td class="px-2 py-1 font-medium">
            {{ item.value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { unit } from '@/lib/mapping'
import ListingFiles from '@/views/ListingFiles'
import UtilDivider from '@/components/utils/UtilDivider'

export default {
  name: 'ListingDetails',
  components: {
    ListingFiles,
    UtilDivider
  },
  props: {
    isLoading: Boolean,
    listing: {
      type: Object,
      required: true
    },
    listingIs: {
      type: Object,
      required: true
    }
  },
  computed: {
    compSampleAnalysis() {
      let data = [
        {
          name: this.$t('formFields.dryMatter'),
          value: `${this.listing.meta.dryMatter} %`,
          active: this.listing.meta.dryMatter
        },
        {
          name: this.$t('formFields.me'),
          value: `${this.listing.meta.me} MJ/kg`,
          active: this.listing.meta.me
        },
        {
          name: this.$t('formFields.cp'),
          value: `${this.listing.meta.cp} %`,
          active: this.listing.meta.cp
        },
        {
          name: this.$t('formFields.cut'),
          value: this.listing.meta.cut,
          active: this.listing.meta.cut
        },
        {
          name: this.$t('formFields.harvestYear'),
          value: this.listing.meta.harvestYear[0],
          active: this.listing.meta.harvestYear && this.listing.meta.harvestYear.length
        },
        {
          name: this.$t('formFields.preservationMethod'),
          value: this.listing.quantityUnit === unit.BALE ? 'Baled' : this.listing.meta.preservation,
          active: this.listing.meta.preservation || this.listing.quantityUnit === unit.BALE
        },
        {
          name: this.$t('formFields.averageBaleWeight'),
          value: `${this.listing.meta.averageWeight} Kg`,
          active: this.listing.meta.averageWeight && this.listing.meta.averageWeight !== '0.00'
        },
        {
          name: this.$t('formFields.baledShape'),
          value: this.listing.meta.baledShape,
          active: this.listingIs.bale
        },
        {
          name: this.$t('formFields.baledSize'),
          value: this.listing.meta.baledSize,
          active: this.listingIs.bale
        }
      ]

      return data.filter(item => item.active)
    }
  }
}
</script>
